import { css } from '@emotion/css'
import { spacing, fontSize, fontFamily, fontWeight, borderRadius } from '../../styles'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  container: css({
    maxWidth: '100%',
  }),

  wrapper: css({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
  }),

  textarea: css({
    boxSizing: 'border-box',
    width: '100%',
    border: 0,
    borderRadius: borderRadius.default,
    padding: spacing.default,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    lineHeight: 1.2,
    color: colors.jumbo,
    resize: 'vertical',
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',

    '&::placeholder': {
      color: colors.grayChateau,
    },

    '&[readonly]': {
      userSelect: 'none',
      backgroundColor: colors.athensGray,
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  wrapperError: css({
    borderColor: colors.mandy,

    '&:focus-within': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus-within': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}

export const textareaSize = size => {
  switch (size) {
    case 'small':
      return css({
        minHeight: 60,
        maxHeight: 150,
      })

    case 'medium':
      return css({
        minHeight: 150,
        maxHeight: 350,
      })

    case 'large':
      return css({
        minHeight: 200,
        maxHeight: 400,
      })

    default:
      return css({
        minHeight: 100,
        maxHeight: 300,
      })
  }
}

export const textareaResize = autosize =>
  css({
    ...(autosize && {
      resize: 'none',
    }),
  })
